/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Details of an existing vehicle booking, returned by GET /vehicle-booking/{gondola_booking_id}.
 * @export
 * @interface VehicleBookingDetails
 */
export interface VehicleBookingDetails {
    /**
     * User-facing confirmation number
     * @type {string}
     * @memberof VehicleBookingDetails
     */
    gondolaBookingId: string;
    /**
     * Travelport Universal Record locator
     * @type {string}
     * @memberof VehicleBookingDetails
     */
    providerBookingId?: string;
    /**
     * One of PENDING, CONFIRMED, CANCELLED, FAILED.
     * @type {string}
     * @memberof VehicleBookingDetails
     */
    bookingStatus: string;
    /**
     * Supplier code (e.g. "ZE" for Hertz)
     * @type {string}
     * @memberof VehicleBookingDetails
     */
    vendorCode: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleBookingDetails
     */
    vendorName?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleBookingDetails
     */
    pickupLocationCode: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleBookingDetails
     */
    pickupLocationType?: string;
    /**
     * 
     * @type {Date}
     * @memberof VehicleBookingDetails
     */
    pickupDatetime: Date;
    /**
     * 
     * @type {string}
     * @memberof VehicleBookingDetails
     */
    dropoffLocationCode: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleBookingDetails
     */
    dropoffLocationType?: string;
    /**
     * 
     * @type {Date}
     * @memberof VehicleBookingDetails
     */
    dropoffDatetime: Date;
    /**
     * 
     * @type {string}
     * @memberof VehicleBookingDetails
     */
    acrissCode: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleBookingDetails
     */
    vehicleClass?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleBookingDetails
     */
    vehicleCategory?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleBookingDetails
     */
    vehicleDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleBookingDetails
     */
    transmissionType?: string;
    /**
     * 
     * @type {number}
     * @memberof VehicleBookingDetails
     */
    passengerCount?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleBookingDetails
     */
    bagCount?: number;
    /**
     * Decimal as string to preserve precision.
     * @type {string}
     * @memberof VehicleBookingDetails
     */
    dailyRate?: string;
    /**
     * Decimal as string to preserve precision.
     * @type {string}
     * @memberof VehicleBookingDetails
     */
    totalRate?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleBookingDetails
     */
    billingCurrency?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleBookingDetails
     */
    rateCode?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleBookingDetails
     */
    rateCategory?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleBookingDetails
     */
    unlimitedMileage?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VehicleBookingDetails
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleBookingDetails
     */
    pickupCounterLocation?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleBookingDetails
     */
    pickupShuttleInfo?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleBookingDetails
     */
    pickupAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleBookingDetails
     */
    pickupPhone?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleBookingDetails
     */
    dropoffCounterLocation?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleBookingDetails
     */
    dropoffShuttleInfo?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleBookingDetails
     */
    dropoffAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleBookingDetails
     */
    dropoffPhone?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleBookingDetails
     */
    cancellationPolicy?: string;
    /**
     * 
     * @type {Date}
     * @memberof VehicleBookingDetails
     */
    cancelledAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof VehicleBookingDetails
     */
    createdAt?: Date;
}

/**
 * Check if a given object implements the VehicleBookingDetails interface.
 */
export function instanceOfVehicleBookingDetails(value: object): value is VehicleBookingDetails {
    if (!('gondolaBookingId' in value) || value['gondolaBookingId'] === undefined) return false;
    if (!('bookingStatus' in value) || value['bookingStatus'] === undefined) return false;
    if (!('vendorCode' in value) || value['vendorCode'] === undefined) return false;
    if (!('pickupLocationCode' in value) || value['pickupLocationCode'] === undefined) return false;
    if (!('pickupDatetime' in value) || value['pickupDatetime'] === undefined) return false;
    if (!('dropoffLocationCode' in value) || value['dropoffLocationCode'] === undefined) return false;
    if (!('dropoffDatetime' in value) || value['dropoffDatetime'] === undefined) return false;
    if (!('acrissCode' in value) || value['acrissCode'] === undefined) return false;
    return true;
}

export function VehicleBookingDetailsFromJSON(json: any): VehicleBookingDetails {
    return VehicleBookingDetailsFromJSONTyped(json, false);
}

export function VehicleBookingDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleBookingDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'gondolaBookingId': json['gondola_booking_id'],
        'providerBookingId': json['provider_booking_id'] == null ? undefined : json['provider_booking_id'],
        'bookingStatus': json['booking_status'],
        'vendorCode': json['vendor_code'],
        'vendorName': json['vendor_name'] == null ? undefined : json['vendor_name'],
        'pickupLocationCode': json['pickup_location_code'],
        'pickupLocationType': json['pickup_location_type'] == null ? undefined : json['pickup_location_type'],
        'pickupDatetime': (new Date(json['pickup_datetime'])),
        'dropoffLocationCode': json['dropoff_location_code'],
        'dropoffLocationType': json['dropoff_location_type'] == null ? undefined : json['dropoff_location_type'],
        'dropoffDatetime': (new Date(json['dropoff_datetime'])),
        'acrissCode': json['acriss_code'],
        'vehicleClass': json['vehicle_class'] == null ? undefined : json['vehicle_class'],
        'vehicleCategory': json['vehicle_category'] == null ? undefined : json['vehicle_category'],
        'vehicleDescription': json['vehicle_description'] == null ? undefined : json['vehicle_description'],
        'transmissionType': json['transmission_type'] == null ? undefined : json['transmission_type'],
        'passengerCount': json['passenger_count'] == null ? undefined : json['passenger_count'],
        'bagCount': json['bag_count'] == null ? undefined : json['bag_count'],
        'dailyRate': json['daily_rate'] == null ? undefined : json['daily_rate'],
        'totalRate': json['total_rate'] == null ? undefined : json['total_rate'],
        'billingCurrency': json['billing_currency'] == null ? undefined : json['billing_currency'],
        'rateCode': json['rate_code'] == null ? undefined : json['rate_code'],
        'rateCategory': json['rate_category'] == null ? undefined : json['rate_category'],
        'unlimitedMileage': json['unlimited_mileage'] == null ? undefined : json['unlimited_mileage'],
        'imageUrl': json['image_url'] == null ? undefined : json['image_url'],
        'pickupCounterLocation': json['pickup_counter_location'] == null ? undefined : json['pickup_counter_location'],
        'pickupShuttleInfo': json['pickup_shuttle_info'] == null ? undefined : json['pickup_shuttle_info'],
        'pickupAddress': json['pickup_address'] == null ? undefined : json['pickup_address'],
        'pickupPhone': json['pickup_phone'] == null ? undefined : json['pickup_phone'],
        'dropoffCounterLocation': json['dropoff_counter_location'] == null ? undefined : json['dropoff_counter_location'],
        'dropoffShuttleInfo': json['dropoff_shuttle_info'] == null ? undefined : json['dropoff_shuttle_info'],
        'dropoffAddress': json['dropoff_address'] == null ? undefined : json['dropoff_address'],
        'dropoffPhone': json['dropoff_phone'] == null ? undefined : json['dropoff_phone'],
        'cancellationPolicy': json['cancellation_policy'] == null ? undefined : json['cancellation_policy'],
        'cancelledAt': json['cancelled_at'] == null ? undefined : (new Date(json['cancelled_at'])),
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
    };
}

export function VehicleBookingDetailsToJSON(json: any): VehicleBookingDetails {
    return VehicleBookingDetailsToJSONTyped(json, false);
}

export function VehicleBookingDetailsToJSONTyped(value?: VehicleBookingDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gondola_booking_id': value['gondolaBookingId'],
        'provider_booking_id': value['providerBookingId'],
        'booking_status': value['bookingStatus'],
        'vendor_code': value['vendorCode'],
        'vendor_name': value['vendorName'],
        'pickup_location_code': value['pickupLocationCode'],
        'pickup_location_type': value['pickupLocationType'],
        'pickup_datetime': value['pickupDatetime'].toISOString(),
        'dropoff_location_code': value['dropoffLocationCode'],
        'dropoff_location_type': value['dropoffLocationType'],
        'dropoff_datetime': value['dropoffDatetime'].toISOString(),
        'acriss_code': value['acrissCode'],
        'vehicle_class': value['vehicleClass'],
        'vehicle_category': value['vehicleCategory'],
        'vehicle_description': value['vehicleDescription'],
        'transmission_type': value['transmissionType'],
        'passenger_count': value['passengerCount'],
        'bag_count': value['bagCount'],
        'daily_rate': value['dailyRate'],
        'total_rate': value['totalRate'],
        'billing_currency': value['billingCurrency'],
        'rate_code': value['rateCode'],
        'rate_category': value['rateCategory'],
        'unlimited_mileage': value['unlimitedMileage'],
        'image_url': value['imageUrl'],
        'pickup_counter_location': value['pickupCounterLocation'],
        'pickup_shuttle_info': value['pickupShuttleInfo'],
        'pickup_address': value['pickupAddress'],
        'pickup_phone': value['pickupPhone'],
        'dropoff_counter_location': value['dropoffCounterLocation'],
        'dropoff_shuttle_info': value['dropoffShuttleInfo'],
        'dropoff_address': value['dropoffAddress'],
        'dropoff_phone': value['dropoffPhone'],
        'cancellation_policy': value['cancellationPolicy'],
        'cancelled_at': value['cancelledAt'] == null ? value['cancelledAt'] : value['cancelledAt'].toISOString(),
        'created_at': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
    };
}

